$(function() {
	//タブ
	$('.id-tab__item').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 600,
		centerMode: false,
		dots: false,
		arrows: false,
		draggable: false,
		adaptiveHeight: true,
		swipe: false,
	});

	function updateIndicator() {
		var $active = $('.id-tab__nav div.active');
		if ($active.length) {
			var navOffset = $active.position().left;
			var navWidth = $active.outerWidth();
			var navColor = $active.data('color');

			$active.parents('.id-tab__nav').find('.indicator').css({
				left: navOffset,
				width: navWidth,
				background: navColor
			});
			if (window.innerWidth <= 768) {
				$('.id-tab__nav div').css({
					background: '#FAFAFA',
					'border-color': '#F0EFEF'
				})
				$active.css({
					background: navColor,
					'border-color': navColor
				});
			}
		}
	}

	$('.id-tab__nav div:not(.indicator)').click(function() {
		var targetSlide = $(this).index();

		$(this).addClass('active').siblings().removeClass('active');
		$('.id-tab__item').slick('slickGoTo', targetSlide);
		updateIndicator();
	});

	//リサイズ時の処理
	$(window).on('resize', function() {
		updateIndicator();
	});

	//読み込み時の処理
	$(window).on('load', function() {
		updateIndicator();
	});

	//マガジン背景アニメーション
	const $magBg = $('.id-mag__track');
	const magBgItems = $magBg.children();
	for (let i = 0; i < 3; i++) {
		$magBg.append(magBgItems.clone());
	}

	//マガジン画像ギャラリー
	const $gallery = $('.id-gallery');
	const originalItems = $gallery.children();
	for (let i = 0; i < 3; i++) {
		$gallery.append(originalItems.clone());
	}

	//PRティッカー
	const $track = $('.id-pr__track');
	const $items = $track.children();
	const itemHeight = $('.id-pr__item').outerHeight(true);
	let index = 0;
	const total = $items.length;

	$track.append($items.first().clone());

	setInterval(() => {
		index++;
		$track.animate({
			top: -itemHeight * index
		}, 500, function() {
			if (index >= total) {
				index = 0;
				$track.css('top', 0);
			}
		});
	}, 4000);

	$('.id-iconnav__item--search').click(function() {
		$('.id-search').toggleClass('active');
	});
	$('.id-search__close').click(function() {
		$('.id-search').removeClass('active');
	});
	
	$('.id-search__form').on('submit', function(e){
	  const query = $(this).find('input[name="q"]').val().trim();
	  if (!query) {
		e.preventDefault();
		return false;
	  }
	});

	//standardボタン
	$('.id-btn--standard').each(function() {
		var arrow = $(this).find('img');
		for (let i = 0; i < 2; i++) {
			$(this).append(arrow.clone());
		}
	});

	//フッターメニュー
	$('.id-footer__link > li.active').find('div').show();
	$('.id-footer__link > li').click(function() {
		if (window.innerWidth <= 768) {
			const $this = $(this);

			if ($this.hasClass('active')) {
				$this.removeClass('active');
				$this.find('div').slideUp();
			} else {
				$this.addClass('active');
				$this.find('div').slideDown();
			}
		}
	});

	$('.id-drawer-nav__item > span').click(function() {
		$(this).toggleClass('active');
		$(this).next('ul').slideToggle();
	});

	$('.id-iconnav__item--menu').click(function() {
		$(this).add('.id-drawer').toggleClass('active');
		$('body,html').toggleClass('noscroll')
		$('.id-drawer').slideToggle();
	});

	$(".id-p-list__item:not(.id-p-list__item--empty)").click(function() {
		window.location = $(this).find('.id-item__name a').attr('href');
	});

	$('.id-sort-nav__item').click(function() {
		var target = $(this).index();

		$(this).addClass('active').siblings().removeClass('active');

		var $container = $(this).parents('.id-page-header__nav');
		$container.find('.id-sort-contents__item').eq(target).slideToggle().siblings().slideUp();
	});

	$('.id-sort-nav__title').click(function() {
		$(this).toggleClass('active');
		$('.id-sort-contents').slideToggle();
	});

	const urlParams = new URLSearchParams(window.location.search);
	const sortBy = urlParams.get('sort_by');
	const $select = $('.id-sort__select select');

	if (sortBy) {
		$select.find('option').each(function() {
			if ($(this).val() === sortBy) {
				$(this).prop('selected', true);
				$('.id-sort__text span').text($(this).text());
			}
		});
	} else {
		const defaultText = $select.find('option:selected').text();
		$('.id-sort__text span').text(defaultText);
	}

	$('.id-sort-contents__title').click(function() {
		$(this).toggleClass('active');
		$(this).next('ul').slideToggle();
	});

	const targets = $('.id-p-caution, .id-p-bnr, .id-p-contents, .id-p-doc');
	const originalParents = [];

	const $cat = $('.id-p-cat');
	const $price = $('.id-p-price');
	const catOriginalParent = $cat.parent();
	const catOriginalIndex = $cat.index();

	// 移動前の親と位置を保存
	targets.each(function() {
		originalParents.push({
			el: $(this),
			parent: $(this).parent(),
			index: $(this).index()
		});
	});

	function moveElements() {
		if (window.innerWidth <= 768) {
			$('.id-p__right').append(targets);
			$price.after($cat); // .id-p-price の直後に .id-p-cat を移動
		} else {
			// 元の位置に戻す
			originalParents.forEach(item => {
				const children = item.parent.children();
				if (children.length > item.index) {
					item.el.insertBefore(children.eq(item.index));
				} else {
					item.parent.append(item.el);
				}
			});

			// .id-p-cat を戻す
			const catSiblings = catOriginalParent.children();
			if (catSiblings.length > catOriginalIndex) {
				$cat.insertBefore(catSiblings.eq(catOriginalIndex));
			} else {
				catOriginalParent.append($cat);
			}
		}
	}

	moveElements();

	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(moveElements, 200);
	});

	gsap.registerPlugin(ScrollTrigger);

	ScrollTrigger.matchMedia({
		"(min-width: 769px)": function() {
			const triggerElement = document.querySelector(".id-p");
			const pinElement = document.querySelector(".id-p__right__inner");
			
			if (triggerElement && pinElement) {
				
				const pinHeight = pinElement.offsetHeight;
				const viewportHeight = window.innerHeight;
				var extraScroll = Math.max(0, pinHeight - viewportHeight);
				if(pinHeight > viewportHeight){
					var extraScroll = Math.max(0, pinHeight - viewportHeight + 90);
				}
				
				ScrollTrigger.create({
					trigger: ".id-p",
					start: "top top",
					end: "bottom bottom+=" + extraScroll,
					pin: ".id-p__right__inner",
					pinSpacing: false,
					scrub: true
				});
				
			}
		},
	});

	//パスワード表示
	$('.pass__view').click(function() {
		var $target = $(this).parents('.pass').find('input');
		$(this).toggleClass('active');

		if ($target.attr('type') === 'text') {
			$target.attr('type', 'password');
		} else {
			$target.attr('type', 'text');
		}
	});
	
	//faq
	$('.id-faq__item dt').click(function(){
		$(this).toggleClass('active');
		$(this).next('dd').slideToggle(300);
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 300);
	});
	
	//peec ai illust
	const interval = setInterval(function() {
	  if ($('.peec-ai-recommend-flow-container').length > 0) {
		$('.peec-ai-recommend-flow-container').append($('.id-illust--add').fadeIn());
		clearInterval(interval); // 一度だけ処理したい場合
	  }
	}, 300);
	
});